import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { AbstractWidget } from '@jeppesen-foreflight/jmkw-toolkit';

@Component({
  standalone: true,
  imports: [CommonModule],
  templateUrl: './air-temperature-widget.component.html',
  styleUrl: './air-temperature-widget.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AirTemperatureWidgetComponent extends AbstractWidget {
  subtitle = computed(() =>
    this.toolkitApiService.getUnitConfig().temperature === 'FAHRENHEIT'
      ? 'In Degrees Fahrenheit'
      : 'In Degrees Celsius'
  );

  override closeWidget(): void {
    const layer = this.toolkitApiService.getLayerById('air-temperature');
    if (layer) {
      layer.visible = false;
    }
  }
}
